import { styled } from '@mui/material'

export const Frame = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<{ backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(0.75)};
  background-color: ${({ backgroundColor, theme }) => backgroundColor ?? theme.palette.secondary.light};
  width: fit-content;
  height: fit-content;
`
